import { Controller, useFormContext } from 'react-hook-form';
import { Box } from 'enova-frontend-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AboutFormControlProps } from '../../types';
import { CheckboxArea } from '../components/checkboxArea';

import KaminField from './kaminField';
import { KaminVannbarenVarmeField } from './kaminVannbarenVarmeField';
import { BiokjelField } from './biokjelField';

export const Bioenergi: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue } = useFormContext();
  const { t } = useTranslation();
  return (
    <Controller
      name="oppvarmingSelection.oppvarmingBioenergi"
      control={control}
      rules={{
        validate: (value, formValues) => {
          const bio = formValues.oppvarming?.oppvarmingBioenergi;
          if (value && !bio?.kjel?.selected && !bio?.kamin?.selected && !bio?.kaminMedVannbarenVarme?.selected) {
            return t('register.errorMessage.field.oppvarmingBioenergi');
          }
          return true;
        }
      }}
      render={({ field: { value, onChange }, fieldState }) => (
        <CheckboxArea
          i18nPrefix="register.tekniskUtstyr.oppvarmingBioenergi"
          value={!!value}
          error={fieldState.error}
          onChange={(checked: boolean) => {
            onChange(checked);
            if (!checked) {
              setValue(`oppvarming.oppvarmingBioenergi`, undefined);
            }
          }}
        >
          <Box gap={3} display="flex" flexDirection="column">
            <KaminField control={control} />
            <KaminVannbarenVarmeField control={control} />
            <BiokjelField control={control} />
          </Box>
        </CheckboxArea>
      )}
    />
  );
};
